package com.example.borshi.web.firebase

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch

// Minimal runtime smoke test for Firebase connectivity.
fun runFirebaseSmokeTest() {
    val scope = MainScope()
    scope.launch {
        try {
            FirebaseService.getCategories()
            js("console.log('Firebase smoke test: OK')")
        } catch (e: Throwable) {
            js("console.error('Firebase smoke test failed', arguments[0])")(e)
        }
    }
}
